import React, { useMemo } from "react"
import { Row, Col } from "reactstrap"
import BarChartV2 from "./barchartv2"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { layoutModeTypes } from "constants/layout"
import Colors from "constants/Colors"

const TrialWorkerSummaryCard = ({ stats }) => {
  const layoutMode = useSelector(state => state.Layout.layoutModeType)

  const {
    t,
    i18n: { language },
  } = useTranslation()

  const data = {
    labels: [""],
    datasets: [
      {
        label: "Yes",
        data: [stats?.trial_count_yes || 0],
        backgroundColor: "#c7e5c2",
        datalabels: { display: false },
      },
      {
        label: "No",
        data: [stats?.trial_count_no || 0],
        backgroundColor: "#006b77",
        datalabels: { display: false },
      },
    ],
  }

  const options = {
    indexAxis: "y",
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        display: false,
      },
      y: {
        stacked: true,
        display: false,
      },
    },
  }

  return (
    <>
      <Row className="text-start">
        <Col
          sm={12}
          className={`${language !== "en" ? "text-end" : "text-start"}`}
        >
          <h4
            style={{
              fontWeight: "700",
              color:
                layoutMode === layoutModeTypes.LIGHT
                  ? Colors.black
                  : Colors.white,
            }}
          >
            {t("Willing To Work On Trial Operations")}
          </h4>
          <h4 className="fw-bold">{stats?.trial_count_yes || 0}</h4>
        </Col>
      </Row>

      {/* <Row className="text-start my-3">
        <Col>
          <div className="d-flex justify-content-between flex-wrap">
            <div
              style={{
                color:
                  layoutMode === layoutModeTypes.LIGHT
                    ? Colors.black
                    : Colors.white,
              }}
            >
              <span style={{ color: "#c7e5c2", marginInlineEnd: "8px" }}>
                ●
              </span>
              {t("Yes")}: {stats?.trial_count_yes?.toLocaleString() || 0}
            </div>
            <div
              style={{
                color:
                  layoutMode === layoutModeTypes.LIGHT
                    ? Colors.black
                    : Colors.white,
              }}
            >
              <span style={{ color: "#006b77", marginInlineEnd: "8px" }}>
                ●
              </span>
              {t("No")}: {stats?.trial_count_no?.toLocaleString() || 0}
            </div>
          </div>
        </Col>
      </Row>

      <BarChartV2 data={data} options={options} height={50} /> */}
    </>
  )
}

export default TrialWorkerSummaryCard
